/**
 * Calculate printing cost based on preferences
 * Pricing:
 * A4: B&W = Rs 2/-, Color = Rs 10/-
 * A3: B&W = Rs 5/-, Color = Rs 20/-
 */
export const calculatePrintCost = (totalPages, preferences) => {
  let baseCost;
  if (preferences.paper_size === 'A3') {
    baseCost = preferences.color_mode === 'color' ? 20.0 : 5.0;
  } else {
    baseCost = preferences.color_mode === 'color' ? 10.0 : 2.0;
  }
  const total = totalPages * preferences.copies * baseCost;
  return total.toFixed(2);
};

/**
 * Validate phone number (10 digits only)
 */
export const formatPhoneInput = (value) => {
  const digitsOnly = value.replace(/\D/g, '');
  return digitsOnly.slice(0, 10);
};
